const DNI = /^[0-9]{8}[A-Za-z]$/;
const NIE = /^[XYZxyz][0-9]{7}[A-Za-z]$/;
const TELEFONO_ES = /^\+34[6789][0-9]{8}$/;
const CIF = /^[A-Za-z][0-9]{6,}[A-Za-z0-9]?$/;

function compacto(value) {
  return (value || '').replace(/\s+/g, '');
}

export function esDniNie(value) {
  const texto = compacto(value);
  return DNI.test(texto) || NIE.test(texto);
}

export function esTelefonoEspana(value) {
  return TELEFONO_ES.test(compacto(value));
}

export function esCif(value) {
  return CIF.test(compacto(value));
}

export function aniosNacimiento(ahora = new Date()) {
  const mayor = ahora.getFullYear() - 18;
  const menor = ahora.getFullYear() - 120;
  const anios = [];
  for (let year = mayor; year >= menor; year -= 1) {
    anios.push(year);
  }
  return anios;
}

export function diasDelMes(anio, mes) {
  return new Date(anio, mes, 0).getDate();
}
